import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { EscalationTypeLookupComponent } from './escalation-type-lookup.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule
  ],
  declarations: [EscalationTypeLookupComponent],
  exports: [EscalationTypeLookupComponent]
})
export class EscalationTypeLookupModule { }
